import { render } from "./EntryList.vue?vue&type=template&id=3522d9f0&scoped=true"
import script from "./EntryList.vue?vue&type=script&lang=js"
export * from "./EntryList.vue?vue&type=script&lang=js"

import "./EntryList.vue?vue&type=style&index=0&id=3522d9f0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3522d9f0"]])

export default __exports__